<div *ngIf="cumulative">
    <ion-col size-md="6" size-xs="12">
        <ion-card class="card-compare">
            <ion-card-header>Cumulative
                [{{ compareManager.compareDates[0] | date:'yyyy-MM-dd HH:mm' }}
                - {{ compareManager.compareDates[compareManager.compareDates.length - 1] | date:'yyyy-MM-dd HH:mm' }}[
                <span *ngIf="compareManager.globalQualityIndicator !== null"
                      [ngClass]="{
                        'quality-good': compareManager.globalQualityIndicator >= 0.5,
                        'quality-medium': compareManager.globalQualityIndicator < 0.5 && compareManager.globalQualityIndicator >= 0,
                        'quality-bad': compareManager.globalQualityIndicator < 0
                      }"
                      class="quality-indicator">
                    Quality: {{ compareManager.globalQualityIndicator | number:'1.0-2' }}
                </span>
            </ion-card-header>
            <ion-card-content *ngIf="compareManager.globalComparePoints?.length">
                <raain-compare
                        (selectedPoint)="onClick($event)"
                        [compareIndex]="0"
                        [currentHeight]="500"
                        [pointMax]="compareManager.globalComparePointsMax"
                        [points]="compareManager.globalComparePoints"></raain-compare>
            </ion-card-content>
        </ion-card>
    </ion-col>
    <div class="ion-text-end">
        <ion-button (click)="exportCumulativeToCsv()" *ngIf="compareManager.globalComparePoints?.length" fill="clear"
                    size="small">
            <ion-icon name="download-outline" slot="start"></ion-icon>
            Export CSV
        </ion-button>
    </div>
</div>

<div *ngIf="!cumulative">
    <ion-col *ngFor="let compare of  compareManager?.uiCompares; index as compareIndex" size-md="6" size-xs="12">
        <ion-card class="card-compare">
            <ion-card-header>Gauges filled {{ compare.name }} {{ compare.remarks }}
                <span *ngIf="compare.qualityIndicator !== null"
                      [ngClass]="{
                        'quality-good': compare.qualityIndicator >= 0.5,
                        'quality-medium': compare.qualityIndicator < 0.5 && compare.qualityIndicator >= 0,
                        'quality-bad': compare.qualityIndicator < 0
                      }"
                      class="quality-indicator">
                    Quality: {{ compare.qualityIndicator | number:'1.0-2' }}
                </span>
            </ion-card-header>
            <ion-card-content *ngIf="compare.comparePoints?.length">
                <raain-compare
                        (selectedPoint)="onClick($event)"
                        [compareIndex]="compareIndex"
                        [currentHeight]="500"
                        [pointMax]="compare.comparePointsMax"
                        [points]="compare.comparePoints"></raain-compare>
            </ion-card-content>
        </ion-card>
    </ion-col>

    <div class="ion-text-end">
        <ion-button (click)="exportGranularToCsv()" *ngIf="compareManager.uiCompares?.length" fill="clear" size="small">
            <ion-icon name="download-outline" slot="start"></ion-icon>
            Export CSV
        </ion-button>
    </div>

    <!-- Cumulative summary of all granular comparisons -->
    <ion-col *ngIf="compareManager.granularCumulativePoints?.length" size-md="6" size-xs="12">
        <ion-card class="card-compare card-compare-cumulative">
            <ion-card-header>Cumulative Summary
                [{{ compareManager.compareDates[0] | date:'yyyy-MM-dd HH:mm' }}
                - {{ compareManager.compareDates[compareManager.compareDates.length - 1] | date:'yyyy-MM-dd HH:mm' }}[
                <span *ngIf="compareManager.granularCumulativeQualityIndicator !== null"
                      [ngClass]="{
                        'quality-good': compareManager.granularCumulativeQualityIndicator >= 0.5,
                        'quality-medium': compareManager.granularCumulativeQualityIndicator < 0.5 && compareManager.granularCumulativeQualityIndicator >= 0,
                        'quality-bad': compareManager.granularCumulativeQualityIndicator < 0
                      }"
                      class="quality-indicator">
                    Quality: {{ compareManager.granularCumulativeQualityIndicator | number:'1.0-2' }}
                </span>
            </ion-card-header>
            <ion-card-content>
                <raain-compare
                        (selectedPoint)="onClick($event)"
                        [compareIndex]="-1"
                        [currentHeight]="500"
                        [pointMax]="compareManager.granularCumulativePointsMax"
                        [points]="compareManager.granularCumulativePoints"></raain-compare>
            </ion-card-content>
        </ion-card>
    </ion-col>
</div>
